import React, { useState } from "react";
import DrawerFilter from "../../../components/listing/DrawerFilter";
import ContratoAutocomplete from "../../../components/autocomplete/ContratoAutocomplete";
import ContratoDescripcionAutocomplete from "../../../components/autocomplete/ContratoDescripcionAutocomplete";

export default function FiltroContrato({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  const [contratoObj, setContratoObj] = useState(initialFilters.contratoObj || null);
  const [descripcionObj, setDescripcionObj] = useState(initialFilters.descripcionObj || null);
  const [fechaContrato, setFechaContrato] = useState(initialFilters.data || "");
  const [fechaInicio, setFechaInicio] = useState(initialFilters.dataFechaini || "");
  const [fechaFin, setFechaFin] = useState(initialFilters.dataFechafin || "");

  const [isLoading, setIsLoading] = useState(false);

  const handleApply = () => {
    setIsLoading(true);
   onSubmit({
  contratoObj,
  descripcionObj,
  data: fechaContrato,
  dataFechaini: fechaInicio,
  dataFechafin: fechaFin,
});
    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Contratos"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      <div className="text-sm text-gray-500 italic">
        Ingrese los criterios para filtrar la lista de contratos:
      </div>

      <div>
  <label className="form-label-fil">Código del Contrato:</label>
  <ContratoAutocomplete
    value={contratoObj}
    onChange={setContratoObj}
    placeholder="Buscar por código..."
  />
</div>

      <div>
  <label className="form-label-fil">Descripción del Contrato:</label>
  <ContratoDescripcionAutocomplete
    value={descripcionObj}
    onChange={setDescripcionObj}
    placeholder="Buscar por descripción..."
  />
</div>

      <div>
        <label className="form-label-fil">Fecha del Contrato:</label>
        <input
          type="date"
          value={fechaContrato}
          onChange={(e) => setFechaContrato(e.target.value)}
          className="mt-1 block w-full border border-gray-300 rounded-full shadow-sm p-2 px-4 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      <div>
        <label className="form-label-fil">Fecha Inicio:</label>
        <input
          type="date"
          value={fechaInicio}
          onChange={(e) => setFechaInicio(e.target.value)}
          className="mt-1 block w-full border border-gray-300 rounded-full shadow-sm p-2 px-4 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      <div>
        <label className="form-label-fil">Fecha Final:</label>
        <input
          type="date"
          value={fechaFin}
          onChange={(e) => setFechaFin(e.target.value)}
          className="mt-1 block w-full border border-gray-300 rounded-full shadow-sm p-2 px-4 focus:ring-green-500 focus:border-green-500"
        />
      </div>
    </DrawerFilter>
  );
}